import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../../axiosInstances";
import { UpdateVigilsPasswordForm } from "../../schemas";
import { eventsQueryKeys } from "../../query-keys";
import { isAxiosError } from "axios";

const updateVigilsPassword = async (
  vigilId: string,
  data: UpdateVigilsPasswordForm
) => {
  const { data: response } = await privateAxios.patch(
    `vigils/${vigilId}/password`,
    data
  );
  return response;
};

export const useUpdateVigilsPasswordMutation = (
  vigilId: string,
  eventId: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateVigilsPasswordForm) =>
      updateVigilsPassword(vigilId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: eventsQueryKeys.get(eventId),
      });
    },
  });
};

const affectInspectorGate = async (vigilId: string, gateId: string | null) => {
  try {
    const { data } = await privateAxios.patch(
      `/vigils/${vigilId}/change-affectation`,
      {
        newGateId: gateId,
      }
    );
    return data;
  } catch (error) {
    if (isAxiosError(error))
      error.message = error.response?.data.message ?? error.message;
    throw error;
  }
};

export const useAffectInspectorGateMutation = (
  vigilId: string,
  eventId: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (gateId: string | null) => affectInspectorGate(vigilId, gateId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: eventsQueryKeys.get(eventId),
      });
    },
  });
};
